module.exports = __webpack_public_path__ + "static/media/bank_jtyh.9cca3743.png";